/**
 * Keep the View in Arrow Builder card href in sync with the selected variant.
 */
(function () {
  function bindCard(card) {
    const link = card.querySelector('[data-ab-link]');
    const mapEl = card.querySelector('[data-ab-variant-map]');
    if (!link || !mapEl) return;

    let map = {};
    try {
      map = JSON.parse(mapEl.textContent || '{}') || {};
    } catch (e) {
      map = {};
    }

    const builderUrl = card.dataset.builderUrl || '/pages/3d-custom-arrow-builder';

    function applyVariant(variantId) {
      const id = String(variantId || '');
      const query = map[id];
      if (!query) return;
      link.setAttribute('href', builderUrl + '?' + query);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event && event.data && event.data.variant;
        if (variant && variant.id) applyVariant(variant.id);
      });
    }

    const formId = card.dataset.productFormId;
    if (formId) {
      const form = document.getElementById(formId);
      const input = form && form.querySelector('input[name="id"]');
      if (input) {
        input.addEventListener('change', function () {
          applyVariant(input.value);
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-view-in-arrow-builder]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
